export default __webpack_public_path__ + "static/media/107_desktop.75c87d92.jpg";